// extracted by mini-css-extract-plugin
module.exports = {"load":"page-load_load__IT5Jm","fadenum":"page-load_fadenum__BUbGt"};